import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getSearchData, getSubsectionNumber, getDataGroup, dataGroupResetSearch, dataGroupSetSelected } from 'actions';
import Calendar from 'lib/Calendar';
import has from 'lodash/has';
import flatMap from 'lodash/flatMap';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';

import Loading from 'components/common/Loading';
import EventDataGroupItem from 'components/calendar/EventDataGroupItem';
import EventDataGroupHeader from 'components/calendar/EventDataGroupHeader';
import Modal from 'components/common/Modal';
import CalendarListSection from 'components/calendar/CalendarListSection';
import DebounceInput from 'components/common/DebounceInput';
import Icon from 'components/common/Icon';

class EventDataGroup extends Component {
  
  static getItemText(item) {
    if (has(item, 'display') && item.display.length > 0) {
      return { __html: unescape(item.display) };
    } else if (has(item, 'primary_fields') && item.primary_fields.length > 0 && has(item, 'other') && item.other.length > 0) {
      return { __html: unescape(item.primary_fields) + ' <span class="other">' + unescape(item.other) + '</span>' };
    } else if (has(item, 'primary_fields') && item.primary_fields.length == 0 && has(item, 'other') && item.other.length > 0) {
      return { __html: unescape(item.other) };
    } else if (has(item, 'primary_fields') && item.primary_fields.length > 0) {
      return { __html: unescape(item.primary_fields) };
    } else {
      return { __html: unescape('---') };
    }
  }

  static sectionToLabel(s) {
    if (s === 'groups') {
      return 'Participants';
    } else if (s === 'event_types') {
      return 'Event Types';
    }
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  constructor(props) {
    super(props);

    this.state = {
      expanded: {},
      search: '',
      showSearch: false,
    };
  }

  componentWillMount() {
    const { parentId, section, subsection, defaultSelected, search, config } = this.props;
    if (defaultSelected) {
      this.props.dataGroupSetSelected(section, subsection, defaultSelected);
    }
    if (isEmpty(search)) {
      if (parentId) {
        this.props.getDataGroup(section, subsection, config, parentId, 'all', null);
      } else {
        this.props.getSubsectionNumber(section, subsection, config, null);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.selectedItems, nextProps.selectedItems)) {
      if (nextProps.onChange) {
        nextProps.onChange(nextProps.selectedItems.reduce((a, b) => {
          if (a !== '') {
            return `${a},${b.prefixedId}`;
          }
          return `${b.prefixedId}`;
        }, ''), nextProps.selectedItems);
      }
    }

    if (!isEqual(this.props.subsection, nextProps.subsection)) {
      if (isEmpty(nextProps.search)) {
        if (nextProps.parentId) {
          this.props.getDataGroup(nextProps.section, nextProps.subsection, nextProps.config, nextProps.parentId, 'all', null);
        } else {
          this.props.getSubsectionNumber(nextProps.section, nextProps.subsection, nextProps.config, null);
        }
      }
    }
  }

  setSearch(search) {
    const { section, subsection, config } = this.props;
    const prevSearch = this.state.search;
    this.setState({ search });

    if (prevSearch !== search) {
      if (isEmpty(search)) {
        this.props.dataGroupResetSearch(section, subsection);
      } else {
        this.props.getSearchData(section, subsection, config, search, null);
      }
    }
  }

  toggleSearch() {
    if (this.state.showSearch) {
      this.setState({ showSearch: false, expanded: {} });
      // Clearing search wasn't working right, I think it's because of the debounce on Search change
      setTimeout(() => {
        this.setSearch('');
      }, 0);
    } else {
      this.setState({ showSearch: true });
    }
  }

  render() {
    const { isLoaded, items, section, subsection, prefixedParentId, selectedItems, secondaryItems, secondaryItemsLabel, secondaryItemsSubsection, thirdItems, thirdItemsLabel, thirdItemsSubsection, config } = this.props;
    const depth = this.props.depth || 0;
    const search = this.state.search ? this.state.search : this.props.search;

    if (!isLoaded) {
      return (
        <Loading withWrapper />
      );
    }

    const sectionLabel = EventDataGroup.sectionToLabel(section);
    const openModalButton = <a className="clickable">Add {sectionLabel} <Icon icon="arrow" className="link-indicator" style={{ marginTop: 0 }} /></a>;
    const renderItem = (item, key) => {
      let isSelectable = true;

      switch (section) {
      case 'equipment':
        isSelectable = false;
        if (item.subsection === 'equipment') {
          isSelectable = true;
        }
        break;
      case 'groups':
        isSelectable = true;
        if (item.subsection === 'school_user') {
          isSelectable = false;
        }
        break;
      case 'locations':
      default:
        isSelectable = true;
      }

      return (
        <EventDataGroupItem
          item={item}
          key={key}
          section={section}
          subsection={subsection}
          config={config}
          parentId={prefixedParentId}
          depth={depth}
          isSelectable={isSelectable}
          search={search}
        />
      );
    };

    const child = (
      <section className="event-data-group">
        <ul>
          {(this.state.showSearch && depth === 0) && (
            <li className="search-container">
              <DebounceInput
                type="search"
                label={`Search ${sectionLabel}`}
                value={search}
                onChange={e => this.setSearch(e.target.value)}
                minLength={2}
                autoFocus
                debounceTimeout={400}
              />
            </li>
          )}
          {(items && items.length > 0) && items.map(renderItem)}
          {(isEmpty(items)) && (!secondaryItemsLabel || secondaryItemsLabel === '') && (!thirdItemsLabel || thirdItemsLabel === '') && (<li>No Results</li>)}
          {(isEmpty(items)) && secondaryItemsLabel && secondaryItemsLabel > '' && (
            <EventDataGroupHeader
              items={items}
              key={`${section}_${subsection}`}
              section={section}
              subsection={subsection}
              mainSubsection={subsection}
              config={config}
              search={search}
              title={sectionLabel}
            />
          )}
        </ul>

        {secondaryItemsLabel && secondaryItemsLabel > '' && (
          <ul>
            <EventDataGroupHeader
              items={secondaryItems}
              key={`${section}_${secondaryItemsSubsection}`}
              section={section}
              subsection={secondaryItemsSubsection}
              mainSubsection={subsection}
              config={config}
              search={search}
              title={secondaryItemsLabel}
            />

          </ul>
        )}

        {thirdItemsLabel && thirdItemsLabel > '' && (
          <ul>
            <EventDataGroupHeader
              items={thirdItems}
              key={`${section}_${thirdItemsSubsection}`}
              section={section}
              subsection={thirdItemsSubsection}
              mainSubsection={subsection}
              config={config}
              search={search}
              title={thirdItemsLabel}
            />

          </ul>
        )}
      </section>
    );

    const searchIcon = this.state.showSearch
      ? (<a className="clickable" onClick={() => this.toggleSearch()}>Cancel</a>)
      : (<Icon icon="search" size="medium" clickable onClick={() => this.toggleSearch()} />);

    if (depth === 0) {
      return (
        <CalendarListSection>
          <h5 style={{ paddingBottom: 8 }}>{EventDataGroup.sectionToLabel(section)}</h5>
          {selectedItems.length > 0 && (
            <ul className="location-list">
              {selectedItems.map((item, key) => (
                <li key={key}>
                  {this.props.selectedRender((<span dangerouslySetInnerHTML={EventDataGroup.getItemText(item)} />), item)}
                </li>
                ))}
            </ul>
          )}
          <Modal
            openByClickOn={openModalButton}
            rightAction={searchIcon}
            title={sectionLabel}
          >
            {child}
          </Modal>
        </CalendarListSection>
      );
    }

    return child;
  }
}

function mapStateToProps(state, ownProps) {
  const { eventDataGroups } = state;
  const { section, subsection, prefixedParentId, config, search } = ownProps;
  const depth = ownProps.depth || 0;

  let items = [];
  let isLoaded = false;
  let selectedItems = [];
  let secondaryItems = [];
  let secondaryItemsLabel = '';
  let secondaryItemsSubsection = '';
  let thirdItems = [];
  let thirdItemsLabel = '';
  let thirdItemsSubsection = '';

  if (((prefixedParentId && search) || !search) && section && subsection && has(eventDataGroups, `search.${section}.${subsection}.root`)) {
    if (prefixedParentId) {
      if (eventDataGroups.search[section][subsection][prefixedParentId]) {
        items = eventDataGroups.search[section][subsection][prefixedParentId].lines;
        isLoaded = true;
      } else {
        isLoaded = true;
        // @TODO not actually loaded at this point and time. We shouldn't be hitting this point but we are for additional subsections in search
      }
    } else {
      items = eventDataGroups.search[section][subsection].root.lines;
      isLoaded = true;

      const mainSubsections = Calendar.getMainSubsections(config);

      if (mainSubsections.length > 1) {
        secondaryItemsSubsection = find(mainSubsections, mainSubsection => mainSubsection !== subsection);
      }

      if (secondaryItemsSubsection > '') {
        secondaryItemsLabel = Calendar.getSubsectionTitles(secondaryItemsSubsection);
        if (has(eventDataGroups, `search.${section}.${secondaryItemsSubsection}.root.lines`)) {
          secondaryItems = eventDataGroups.search[section][secondaryItemsSubsection].root.lines;
        }

        if (mainSubsections.length > 2) {
          thirdItemsSubsection = find(mainSubsections, mainSubsection => (mainSubsection !== subsection && mainSubsection !== secondaryItemsSubsection));

          if (thirdItemsSubsection > '') {
            thirdItemsLabel = Calendar.getSubsectionTitles(thirdItemsSubsection);
            if (has(eventDataGroups, `search.${section}.${thirdItemsSubsection}.root.lines`)) {
              thirdItems = eventDataGroups.search[section][thirdItemsSubsection].root.lines;
            }
          }
        }
      }
    }
  } else if (section && subsection && has(eventDataGroups, `${section}.${subsection}`)) {
    if (prefixedParentId) {
      if (eventDataGroups[section][subsection][prefixedParentId]) {
        items = eventDataGroups[section][subsection][prefixedParentId].lines;
        isLoaded = true;
      }
    } else {
      items = eventDataGroups[section][subsection].root.lines;
      isLoaded = true;

      const mainSubsections = Calendar.getMainSubsections(config);

      if (mainSubsections.length > 1) {
        secondaryItemsSubsection = find(mainSubsections, mainSubsection => mainSubsection !== subsection);
      }

      if (secondaryItemsSubsection > '') {
        secondaryItemsLabel = Calendar.getSubsectionTitles(secondaryItemsSubsection);
        if (has(eventDataGroups, `${section}.${secondaryItemsSubsection}.root.lines`)) {
          secondaryItems = eventDataGroups[section][secondaryItemsSubsection].root.lines;
        }

        if (mainSubsections.length > 2) {
          thirdItemsSubsection = find(mainSubsections, mainSubsection => (mainSubsection !== subsection && mainSubsection !== secondaryItemsSubsection));

          if (thirdItemsSubsection > '') {
            thirdItemsLabel = Calendar.getSubsectionTitles(thirdItemsSubsection);
            if (has(eventDataGroups, `${section}.${thirdItemsSubsection}.root.lines`)) {
              thirdItems = eventDataGroups[section][thirdItemsSubsection].root.lines;
            }
          }
        }
      }
    }
  }

  if (section && subsection && depth === 0) {
    if (has(eventDataGroups, `selected.${section}.${subsection}`)) {
      selectedItems = selectedItems.concat(flatMap(eventDataGroups.selected[section][subsection]));
    }
    if (secondaryItemsSubsection && has(eventDataGroups, `selected.${section}.${secondaryItemsSubsection}`)) {
      selectedItems = selectedItems.concat(flatMap(eventDataGroups.selected[section][secondaryItemsSubsection]));
    }
    if (thirdItemsSubsection && has(eventDataGroups, `selected.${section}.${thirdItemsSubsection}`)) {
      selectedItems = selectedItems.concat(flatMap(eventDataGroups.selected[section][thirdItemsSubsection]));
    }
  }

  return {
    items,
    isLoaded,
    selectedItems,
    secondaryItems,
    secondaryItemsLabel,
    secondaryItemsSubsection,
    thirdItems,
    thirdItemsLabel,
    thirdItemsSubsection,
    config,
    search,
  };
}

export default connect(mapStateToProps, {
  getSearchData,
  getSubsectionNumber,
  getDataGroup,
  dataGroupResetSearch,
  dataGroupSetSelected,
})(EventDataGroup);



// WEBPACK FOOTER //
// ./src/app/components/calendar/EventDataGroup.js